"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAndCreateRelativeConfig = exports.validateAndCreateConfig = exports.createDateList = void 0;
const lodash_1 = __importDefault(require("lodash"));
const luxon_1 = require("luxon");
const common_1 = require("@finley-technologies/common");
const offset_1 = require("../utils/offset");
const range_1 = require("../utils/range");
const getDateForOccurrenceOperator = (startOfPeriodDay, month, occurrence, offset) => {
    // if `inputDay` is from the previous month, add: occurrence, otherwise add: occurrence - 1
    const weeksToAdd = startOfPeriodDay.plus({ months: 1 }).month === month
        ? occurrence
        : occurrence - 1;
    const day = startOfPeriodDay.plus({ weeks: weeksToAdd });
    return day.month === month
        ? (0, offset_1.applyOffset)({
            offset: offset !== null && offset !== void 0 ? offset : { days: 0, dayUnit: 'calendarDay' },
            date: day,
        })
        : null;
};
function isRecurringFrequencyPeriod(period) {
    return period !== undefined;
}
const createDateList = (recurringDateConfig) => {
    (0, common_1.finleyAssert)('type' in recurringDateConfig &&
        recurringDateConfig.type === 'weekdayByOccurrence', 'Recurring date config type must be "weekdayByOccurrence"');
    const { startDate, endDate, period, weekdays, cadence, occurrence, offset, } = recurringDateConfig;
    const startDateTime = luxon_1.DateTime.fromISO(startDate);
    const endDateTime = luxon_1.DateTime.fromISO(endDate);
    const dateList = [];
    let currentDateTime = startDateTime.startOf(period);
    // eslint-disable-next-line no-restricted-syntax
    while (currentDateTime <= endDateTime) {
        const weekYear = currentDateTime.weekYear;
        const weekNumber = currentDateTime.weekNumber;
        // get the weekdays for the first week of the month
        const daysForFirstWeek = weekdays.map((weekday) => luxon_1.DateTime.now().set({
            weekYear,
            weekNumber,
            weekday,
        }));
        const currentMonth = currentDateTime.month;
        // filter out any weekdays out of range
        const newDates = daysForFirstWeek
            .map((day) => getDateForOccurrenceOperator(day, currentMonth, occurrence, offset))
            .filter((date) => date && (0, range_1.isDateInRange)({ date, start: startDate, end: endDate }));
        if (newDates.length > 0) {
            dateList.push(...newDates);
        }
        currentDateTime = currentDateTime.plus({
            [period]: cadence,
        });
    }
    return dateList;
};
exports.createDateList = createDateList;
function validateAndCreateConfig(startDate, endDate, period, cadence = 0, offsetDayUnit = 'calendarDay', offsetDays = 0, weekdays, occurrence) {
    const error = {};
    if (!weekdays || weekdays.length < 1) {
        error.daysOfTheWeek = 'Missing Days of the Week';
    }
    if (weekdays && weekdays.length > 7) {
        error.daysOfTheWeek = 'More than 7 days selected';
    }
    if (period === 'week') {
        error.frequency = 'Frequency cannot be `week`, must be recurring.';
    }
    if (!occurrence || occurrence < 1) {
        error.occurrence = 'Occurrence must be greater than 0';
    }
    if (!lodash_1.default.isEmpty(error)) {
        return { config: null, error };
    }
    if (!isRecurringFrequencyPeriod(period)) {
        return {
            config: null,
            error: { frequency: `Invalid frequency [${period}] provided.` },
        };
    }
    const weekdayConfig = {
        type: 'weekdayByOccurrence',
        startDate,
        endDate,
        occurrence: occurrence,
        period,
        weekdays: weekdays,
        cadence,
        offset: {
            dayUnit: offsetDays === 0 ? 'calendarDay' : offsetDayUnit,
            days: offsetDays,
        },
    };
    return { config: weekdayConfig, error: {} };
}
exports.validateAndCreateConfig = validateAndCreateConfig;
function validateAndCreateRelativeConfig(startDateFormula, endDateFormula, period, cadence = 0, offsetDayUnit = 'calendarDay', offsetDays = 0, weekdays, occurrence) {
    const error = {};
    if (!weekdays || weekdays.length < 1) {
        error.daysOfTheWeek = 'Missing Days of the Week';
    }
    if (weekdays && weekdays.length > 7) {
        error.daysOfTheWeek = 'More than 7 days selected';
    }
    if (period === 'week') {
        error.frequency = 'Frequency cannot be `week`, must be recurring.';
    }
    if (!occurrence || occurrence < 1) {
        error.occurrence = 'Occurrence must be greater than 0';
    }
    if (!lodash_1.default.isEmpty(error)) {
        return { config: null, error };
    }
    if (!isRecurringFrequencyPeriod(period)) {
        return {
            config: null,
            error: { frequency: `Invalid frequency [${period}] provided.` },
        };
    }
    const weekdayConfig = {
        type: 'weekdayByOccurrence',
        occurrence: occurrence,
        period,
        weekdays: weekdays,
        cadence,
        offset: {
            dayUnit: offsetDays === 0 ? 'calendarDay' : offsetDayUnit,
            days: offsetDays,
        },
    };
    return {
        config: { startDateFormula, endDateFormula, baseDateConfig: weekdayConfig },
        error: {},
    };
}
exports.validateAndCreateRelativeConfig = validateAndCreateRelativeConfig;
//# sourceMappingURL=weekdayByOccurrence.js.map